import { render, staticRenderFns } from "./DatatableFilters.vue?vue&type=template&id=40c4f4df"
import script from "./DatatableFilters.vue?vue&type=script&lang=js"
export * from "./DatatableFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports